<div cdkDropListGroup *ngIf="edit">
    <div class="edit-navbar">
        <span class="title">Sélection du template :</span>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>Templates</mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="templateChoose">
                <li><img src="assets/1-1-1.png" (click)="changeTemplate( '1-1-1')"
                         [ngClass]="{'active': userTab.template == '1-1-1'}"/></li>
                <li><img src="assets/1-2.png" (click)="changeTemplate( '1-2')"
                         [ngClass]="{'active': userTab.template == '1-2'}"/></li>
                <li><img src="assets/2-1.png" (click)="changeTemplate( '2-1')"
                         [ngClass]="{'active': userTab.template == '2-1'}"/></li>
                <li><img src="assets/1-1.png" (click)="changeTemplate(  '1-1')"
                         [ngClass]="{'active': userTab.template == '1-1'}"/></li>
                <li><img src="assets/1|1-1-1.png" (click)="changeTemplate( '1/1-1-1')"
                         [ngClass]="{'active': userTab.template == '1/1-1-1'}"/></li>
                <li><img src="assets/1|1-2.png" (click)="changeTemplate( '1/1-2')"
                         [ngClass]="{'active': userTab.template == '1/1-2'}"/></li>
                <li><img src="assets/1|2-1.png" (click)="changeTemplate( '1/2-1')"
                         [ngClass]="{'active': userTab.template == '1/2-1'}"/></li>
                <li><img src="assets/1|1-1.png" (click)="changeTemplate(  '1/1-1')"
                         [ngClass]="{'active': userTab.template == '1/1-1'}"/></li>
            </ul>
        </mat-expansion-panel>

        <span class="title">Sélection des Widgets : </span>

        <mat-expansion-panel *ngFor="let cat of module | keyvalue">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ cat.key }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="widgetChoose" cdkDropList
                 [cdkDropListData]="cat.value"
                 (cdkDropListDropped)="drop($event)">
                <div cdkDrag *ngFor="let item of cat.value">
                    <div [hidden]="isHidden(item)">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>

        <div class="btn-wrapper">
            <button matTooltip="Réinitialiser" (click)="cancelChange()" class="btn btn-danger reinit"><i
                class="fa fa-refresh"></i></button>
            <button matTooltip="Annuler" (click)="back()" class="btn btn-light back"><i
                class="fa fa-arrow-circle-o-left"></i></button>
            <button matTooltip="Enregistrer" (click)="save()" class="btn btn-success save"><i class="fa cfa cfa-save"></i>
            </button>
        </div>
    </div>

    <app-ad-kpis [preview]="preview" [favorite]="favorite" [kpis]="userTab.kpi" *ngIf="kpi"
                 (favoriteChange)="favoriteChange.emit(favorite)"></app-ad-kpis>
    <div class="row">
        <div [hidden]="w1 == 0" [ngClass]="'colWidget col-xl-' + w1">
            <div class="row">
                <div class="col-md-12"
                     cdkDropList
                     [cdkDropListData]="userTab.col1"
                     (cdkDropListDropped)="drop($event)" id="widget1">
                    <div cdkDrag *ngFor="let item of userTab.col1">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="w2 == 0" [ngClass]="'colWidget col-xl-' + w2">
            <div class="row">
                <div class="col-md-12"
                     cdkDropList
                     [cdkDropListData]="userTab.col2"
                     (cdkDropListDropped)="drop($event)" id="widget2">
                    <div cdkDrag *ngFor="let item of userTab.col2">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="w3 == 0" [ngClass]="'colWidget col-xl-' + w2">
            <div class="row">
                <div class="col-md-12"
                     cdkDropList
                     [cdkDropListData]="userTab.col3"
                     (cdkDropListDropped)="drop($event)" id="widget3">
                    <div cdkDrag *ngFor="let item of userTab.col3">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-12"
         cdkDropList
         [cdkDropListData]="[]"
         (cdkDropListDropped)="drop($event)" id="trash">
        <i class="fa cfa cfa-trash"></i>
    </div>
</div>

<div *ngIf="!edit">
    <div class="row">
        <app-ad-kpis [preview]="preview" [favorite]="favorite" [cpt]="cpt" [kpis]="userTab.kpi" *ngIf="kpi"
                     (favoriteChange)="sendChange()"></app-ad-kpis>
    </div>
    <div class="row"
         [stepContent]="widgetsStepContent"
         joyrideStep="widgetsStep">
        <div
            [hidden]="favorite.favorite_list.id == '' || (userTab.col1 != undefined && userTab.col1.length) != 0 || (userTab.col2 != undefined && userTab.col2.length != 0) || (userTab.col3 != undefined && userTab.col3.length) != 0"
            class="col-md-12">
            <div class="content_upgrade card edit_page">
                <img class="img-fluid" src="assets/illustrations/DragAndDrop.png"/>
                <h3>Dashboard personnalisé</h3>
                <p>
                    Créez votre propre affichage sur mesure pour qu’il corresponde 100% à vos besoins.
                </p>
                <a *ngIf="authenticationService.isAllowed('expert')" class="btn btn-primary"
                   [routerLink]="['/app/favorites', favorite.favorite_list.id, favorite.id, tab.slug, 'edit']">
                    Personnaliser cette page
                </a>
                <a *ngIf="!authenticationService.isAllowed('expert')" class="btn btn-primary"
                   (click)="upgradePlan()">
                    Personnaliser cette page
                </a>
            </div>
        </div>

        <div [ngClass]="'colWidget col-xl-' + w1" *ngIf="deviceService.isDesktop()">
            <div class="row">
                <div class="col-md-12">
                    <div *ngFor="let item of userTab.col1">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="w2 == 0" [ngClass]="'colWidget col-xl-' + w2" *ngIf="deviceService.isDesktop()">
            <div class="row">
                <div class="col-md-12">
                    <div *ngFor="let item of userTab.col2">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div [hidden]="w3 == 0" [ngClass]="'colWidget col-xl-' + w3" *ngIf="deviceService.isDesktop()">
            <div class="row">
                <div class="col-md-12">
                    <div *ngFor="let item of userTab.col3">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="'colWidget'" *ngIf="deviceService.isMobile() || deviceService.isTablet()">
            <div class="row">
                <div class="col-md-12">
                    <div *ngFor="let item of mobileTab">
                        <ng-template appAdWidget>{{ item }}</ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #widgetsStepContent>
    <div class="user_onboarding_content">
        <h2>Comment fonctionnent les onglets ?</h2>
        <p>
            La seconde partie permet d’aller dans le détail, et de modifier les chiffres.<br/>
            <br/>
            C’est ici que vous pourrez faire une analyse en profondeur de votre projet afin de <b>sécuriser votre
            rentabilité</b>.
        </p>
    </div>
</ng-template>
